import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function cancelAppointment(
  timeslotId: string | number,
  onBehalfOf?: string,
) {
  const queryParams = new URLSearchParams();
  queryParams.append("timeslot_id", timeslotId.toString());
  if (onBehalfOf) {
    queryParams.append("on_behalf_of", onBehalfOf);
  }

  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/timeslot_orchid_pro/cancels_appointment?${queryParams.toString()}`,
    {
      method: "POST",
    },
  );

  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return;
}
